import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { DxButtonModule, DxPopoverModule } from 'devextreme-angular';
import { ButtonStyle, Position } from 'devextreme/common';
import { Observable } from 'rxjs';
import { ContainerComponent } from '../container/container.component';
import DevExpress from 'devextreme';
import { ContainerPopoverContentService } from 'src/app/services/container-popover-content.service';
import { ActivatedRoute } from '@angular/router';
import { ContainerPopoverContent } from 'src/app/models/container-popover-content.interface';

@Component({
	selector: 'app-help-popover-button',
	standalone: true,
	imports: [
		DxButtonModule,
		DxPopoverModule,
	],
	templateUrl: './help-popover-button.component.html',
	styleUrl: './help-popover-button.component.scss',
})
export class HelpPopoverButtonComponent implements OnInit {

	@ViewChild('button', {read: ElementRef})
	public buttonRef: ElementRef;

	@Input()
	public width: number = 24;

	@Input()
	public height: number = 24;

	@Input()
	public stylingMode: ButtonStyle = 'text';

	@Input({required: true})
	public container: ContainerComponent;

	@Input()
	public containerPopoverContent: ContainerPopoverContent;

	@Output()
	public buttonClick = new EventEmitter<void>();

	@Input()
	public popoverPosition: Position | DevExpress.PositionConfig = 'right';

	protected routeId: number;

	constructor(
		private _activatedRoute: ActivatedRoute,
		private _containerPopoverContentService: ContainerPopoverContentService,
	) {}

	ngOnInit(): void {
		this._activatedRoute.data.subscribe(
			{
				next: (data) => {
					this.routeId = data.id;

					this._containerPopoverContentService.getContainersPopoverContents(
						this.routeId,
						{
							showLoadingIndicator: false,
						}
					).subscribe(
						{
							next: (contents: ContainerPopoverContent[]) => {
								this.containerPopoverContent = contents.find((content) => content.containerId === this.container.id);
							}
						}
					);
				}
			}
		);
	}
}
